import { DBP_BASE_URL, DBP_KEY } from '../../common/util/dbp';
import {notEmpty} from '../helpers';
import isEmpty from 'lodash/isEmpty';

export class Mp3VersionsCombo {
    copyrightNode;
    textValueSelector;
    container;
    versionParam;
    versions = [];

    //callbacks
    hideError;
    printError;
    setParams;
    setVersion;
    onVersionRender;

    constructor({ container, copyrightNode, textValueSelector, versionParam}) {
        this.copyrightNode = copyrightNode;
        this.textValueSelector = textValueSelector;
        this.container = container;
        this.versionParam = versionParam;

    }
    async fetchVersions(lang, selectedDamId) {
        if ( !lang ) return; 
        this.onVersionRender(false);    
        changeSearchDiv(this.container);
    
        try {
          this.versions = await searchMp3(lang);
    
          this.renderVersions(this.versions, selectedDamId); 
          if ( !isEmpty( this.versions ) ){        
            if(this.versionParam) this.setVersion(this.versionParam);
          }
    
          const s = selectedDamId ? selectedDamId : this.versions[0]?.filesets.id;
          if (!s) {
            this.setParams()
          }
          this.renderCopyright(s);
    
        } catch (error) {
          console.error(error);
          this.printError("An error occurred. Please try again later.");
        }
      }
      renderVersions(json, selectedDamId) {
        //	remove previous versions        
        while (this.container.firstChild) {
            this.container.removeChild(this.container.firstChild);
        }
    
        if (json.length > 0) {
          this.onVersionRender(true);
          for (let i = 0; i < json.length; i++) {
            const j = json[i];
            const testamentInitial = j.filesets.id.slice(6, 7);
            const testament = "";
            if (testamentInitial == "N") {
              testament = "New Testament";
            } else if (testamentInitial == "O") {
              testament = "Old Testament";
            } else if (testamentInitial == "P") {
              testament = "Partial";
            }
    
            const node = document.createElement("A");
            node.href = "#";
            node.classList.add("dropdown-link", "w-dropdown-link");
            let title = isEmpty(j.vname)? j.name: j.vname;
            const textNode = document.createTextNode(title + " " + j.filesets.type?.replaceAll('_', '-') + " " + testament);
            node.id = j.filesets.id;
            node.appendChild(textNode);
            node.addEventListener("click", () => {
                this.onVersionChange(node.id, node.textContent, true);
                this.setParams();
            });
            this.container.appendChild(node);
    
            if (selectedDamId && selectedDamId.toLowerCase() == j.filesets.id.toLowerCase()) {
              node.selected = true;
              this.onVersionChange(node.id, node.textContent);
            }
          }
        } else {
          this.onVersionRender(false);
          const node = document.createElement("A");
          node.href = "#";
          node.classList.add("dropdown-link", "w-dropdown-link");
          const textNode = document.createTextNode("No versions available.");
          node.appendChild(textNode);
          node.id = "noVersion";
          this.container.appendChild(node);
          if (!selectedDamId) {
            this.onVersionChange(this.container.firstElementChild.id, this.container.firstElementChild.textContent);
            this.setParams();
          }
        }
      }
      onVersionChange(damId, textContent, isEventChange = false) {
        if (! damId) return;

        const textValue = document.querySelector(this.textValueSelector);
        textValue.setAttribute("data-value", damId);
        textValue.textContent = textContent;
        textValue.style.overflow = "hidden";
    
        if ( isEventChange ){
            textValue.dispatchEvent(
            new MouseEvent("mouseup", {
              view: window,
              bubbles: true,
              cancelable: false,
            })
          );
          textValue.dispatchEvent(
            new MouseEvent("click", {
              view: window,
              bubbles: true,
              cancelable: false,
            })
          );
          this.renderCopyright(damId);
        }
        return;
      }
    
      async renderCopyright(damId) {
        while (this.copyrightNode.lastChild) {
          this.copyrightNode.removeChild(this.copyrightNode.lastChild);
        }
    
        if (!damId) {
          return;
        }
    
        let details = {};
        const url = `${DBP_BASE_URL}/api/bibles/filesets/${damId}/copyright?key=${DBP_KEY}&v=4`;
        try {
          const {data}  = await FCBH.axiosInstance.get( url );
          if (notEmpty(data)) {
            details["copyrightMark"] = data.copyright.copyright.replaceAll('\n', '<br>'); 
            details['organizations'] = [];
              for (var j = 0; j < data.copyright.organizations.length; j++) {
                details['organizations'].push({
                  copyrighter: data.copyright.organizations[j].slug,
                  copyrighterURL: data.copyright.organizations[j].url_website
                });
              }
          }
    
          if (notEmpty(details)) {
            if (details.copyrightMark) {
              const span = document.createElement("span");
              span.innerHTML = details.copyrightMark;
              span.classList.add("block");
              this.copyrightNode.appendChild(span);
            }
    
            for (var j = 0; j < details.organizations.length; j++) {
              const span = document.createElement("span");
              span.innerHTML = "<br><a href='" +( details.organizations[j].copyrighterURL?? "#") + "'>" + details.organizations[j].copyrighter + "</a>";
              span.classList.add("block");
              this.copyrightNode.appendChild(span);
            }
          } else {
            this.copyrightNode.textContent = "No copyright information available.";
          }
        } catch (error) {
          console.error(error);
        }
        
      }
}
async function searchMp3(lang) {
    if ( !lang ) return []; 

    let versions = [];
    let versionIds = [];
    await getVersions(lang, "audio", versions, versionIds);
    await getVersions(lang, "audio_drama", versions, versionIds);
    return versions;
}
async function getVersions(lang, media, versions, versionIds) {
    if ( !lang ) return []; 

    const baseUrl = `${DBP_BASE_URL}/api/bibles?key=${DBP_KEY}&media=${media}&language_code=${lang.language_family_code}&v=4`;
    const { data } = await FCBH.axiosInstance.get( baseUrl );
    const audio = data?.data;
    
    for (let i = 0; i < audio.length; i++) {
        const filesets = audio[i].filesets['dbp-prod']?? audio[i].filesets;
        for (let j=0; j< filesets.length;j++) {
            const version = audio[i]; //there is no zipfile for versions with 16kbps bitrate
            if (!versionIds.includes(filesets[j].id) && filesets[j].codec?.toLowerCase() === 'mp3' && filesets[j].bitrate?.toLowerCase() !== '16kbps') {
              const fileVersion = Object.assign({},version);
              fileVersion.filesets = filesets[j];
              versions.push(fileVersion);
              versionIds.push(fileVersion.filesets.id);
            }
        }
    }
    return versions;
  }
  export async function getFileUrl(version){
    const baseUrl = `${DBP_BASE_URL}/api/bibles/filesets/${version.filesets.id}?key=${DBP_KEY}&v=4`;

      const { data: {meta} } = await FCBH.axiosInstance.get( baseUrl );
      return meta;
  }

  function changeSearchDiv(containerList) {
    if (containerList.parentNode.firstChild.firstChild) containerList.parentNode.firstChild.firstChild.innerHTML= "Select";
  }